import Checkbox from "components/Checkbox";
import Trainers from "components/Trainers";
import RosterContext from "context/roster.context";
import useWindowSize from "hooks/useWindowSize";
import variables from "theme/variables";
import { InfieldPositions, OutfieldPositions, PitcherPositions } from "types/Player";
import ITrainer from "types/Trainer";
import { jsonTrainers } from "utils/json";
import { faLockOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useMemo, useState } from "react";
import { StepProps } from "../Form";
import FormNav from "../FormNav";
import FormStyles from "../styled";

const LockIcon = <FontAwesomeIcon icon={faLockOpen} />;

type OwnProps = {
  onSelected: (trainers: ITrainer[]) => any;
  onLock: (trainers: string[]) => any;
};

type Props = StepProps & OwnProps;

const ChooseTrainers = (props: Props) => {
  const [trainers, setTrainers] = useState<ITrainer[]>([]);
  const [selected, setSelected] = useState<ITrainer[]>([]);
  const [locked, setLocked] = useState<string[]>(props.locked || []);
  const [onlyRoster, setOnlyRoster] = useState(false);
  const { roster } = useContext(RosterContext);

  // const positions = useMemo(() => {
  //   // if (props.type === "batter") {
  //   //   return [...Object.keys(InfieldPositions), ...Object.keys(OutfieldPositions)];
  //   // } else {
  //   //   return Object.keys(PitcherPositions);
  //   // }
  // }, [props.type]);

  const positions = [
    ...Object.keys(InfieldPositions),
    ...Object.keys(OutfieldPositions),
    ...Object.keys(PitcherPositions),
  ];

  useEffect(() => {
    const baseTrainers = onlyRoster ? roster : jsonTrainers;

    const _trainers = baseTrainers
      .filter((trainer) => positions.includes(trainer.position))
      .map((trainer) => {
        if (!trainer.level) {
          trainer.level = 1;
        } else if (trainer.level < 1) {
          trainer.level = 1;
        } else if (trainer.level > 5) {
          trainer.level = 5;
        }

        return trainer;
      });

    setTrainers(_trainers);
  }, [onlyRoster, props.type]);

  useEffect(() => {
    props.onSelected(selected);
  }, [selected]);

  useEffect(() => {
    props.onLock(locked);
  }, [locked]);

  const { width } = useWindowSize();

  return (
    <FormStyles.Step>
      <FormStyles.StepContent
        style={{
          padding: width <= 500 ? `${variables.SPACING * 2}px` : `${variables.SPACING * 4}px`,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0",
            marginBottom: "16px",
          }}
        >
          <span style={{ fontWeight: 600 }}>Choose the trainers (minimum 7)</span>
          {roster.length > 0 && (
            <Checkbox
              style={{
                marginLeft: "32px",
              }}
              label={"Use Roster"}
              onChecked={setOnlyRoster}
              checked={onlyRoster}
            />
          )}
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "16px",
          }}
        >
          {" "}
          <div>
            You can click the lock icon ( {LockIcon} ) on the top left of each trainer if you want to force them to be
            included in all the decks (There can be up to 5 locked trainers)
          </div>
        </div>
        <div
          style={{
            maxWidth: "1920px",
            margin: "auto",
          }}
        >
          <Trainers
            trainers={trainers}
            setTrainers={setTrainers}
            setSelected={setSelected}
            setLocked={setLocked}
            locked={locked}
            selected={props.trainers}
            withLocks
          />
        </div>
      </FormStyles.StepContent>
      <FormNav
        {...props}
        nextText={`Next (${selected.length} trainers)`}
        nextDisabled={selected.length <= 6}
        nextActive={selected.length > 6}
      />
    </FormStyles.Step>
  );
};

export default ChooseTrainers;
